module.exports = __webpack_public_path__ + "static/media/gokrisp-sample.5ceb25ec.png";